export const STORE_KEY_USER_TOKEN = "user-token";
export const STORE_KEY_ADMIN_INFO = "admin-info";
export const STORE_KEY_ADMIN_ROUTE= 'admin-route';

export const GetLocalStorageT = (key) => {
    let nowTime = new Date().getTime();
    try {
        let obj = JSON.parse(window.localStorage.getItem(key));
        let expire = obj._timestamp + obj._timeout;
        if (obj._timeout == 0 || expire > nowTime) {
            return obj.data;
        }
        return null;
    } catch (exception) {
        return null;
    }
};

export const GetLocalStorageT2 = (key) => {
    let nowTime = new Date().getTime();
    try {
        let obj = JSON.parse(window.localStorage.getItem(key));
        let expire = obj._timestamp + obj._timeout;
        if (obj._timeout == 0 || expire > nowTime) {
            return { data: obj.data, expire: expire };
        }
        return null;
    } catch (exception) {
        return null;
    }
};

export const SetLocalStorageT = (key, value, timeout) => {
    let nowTime = new Date().getTime();
    let obj = {
        _timestamp: nowTime,
        _timeout: timeout * 1000,
        data: value,
    };
    window.localStorage.setItem(key, JSON.stringify(obj));
};

export const SetSessionStorage = (key, value) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const GetSessionStorage = (key) => {
    try {
        let obj = JSON.parse(window.sessionStorage.getItem(key));
        return obj;
    } catch (exception) {
        return null;
    }
};
